"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TiptapEditor_vue_1 = __importDefault(require("@/Views/Components/Misc/TiptapEditor.vue"));
var moment_1 = __importDefault(require("moment"));
var ImageUploader_vue_1 = __importDefault(require("@/Views/Components/Misc/ImageUploader.vue"));
var vuedraggable_1 = __importDefault(require("vuedraggable"));
var BankSelect_vue_1 = __importDefault(require("./Form/Bank/BankSelect.vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var lodash_1 = __importDefault(require("lodash"));
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var toastNotification_1 = __importDefault(require("@/Modules/Misc/toastNotification"));
var routes_1 = require("@/routes");
var currency_js_1 = __importDefault(require("currency.js"));
var CurrencyInput_vue_1 = __importDefault(require("@/Views/Components/Misc/CurrencyInput.vue"));
var DatePicker_vue_1 = __importDefault(require("@/Views/Components/Misc/DatePicker.vue"));
var components = {
    Editor: TiptapEditor_vue_1.default,
    ImageUploader: ImageUploader_vue_1.default,
    draggable: vuedraggable_1.default,
    BankSelect: BankSelect_vue_1.default,
    CurrencyInput: CurrencyInput_vue_1.default,
    DatePicker: DatePicker_vue_1.default,
};
var ItemCreateUpdateForm = /** @class */ (function (_super) {
    __extends(ItemCreateUpdateForm, _super);
    function ItemCreateUpdateForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            images: [],
            name: "",
            content: "",
            itemValue: "$0.00",
            initialPrice: "$0.00",
            isOpenToBid: false,
            changeStartTime: false,
            biddingStartedAt: null,
            biddingEndedAt: null,
            bank: "",
            board: {
                id: null,
                name: "",
                code: "",
                abbr: "",
            },
            currentImages: []
        };
        return _this;
    }
    Object.defineProperty(ItemCreateUpdateForm.prototype, "isNotBidOn", {
        get: function () {
            if (this.item) {
                return this.item.bid_count === 0;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemCreateUpdateForm.prototype, "parsedItemValue", {
        get: function () {
            return (0, currency_js_1.default)(this.form.itemValue).value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemCreateUpdateForm.prototype, "parsedInitialPrice", {
        get: function () {
            return (0, currency_js_1.default)(this.form.initialPrice).value;
        },
        enumerable: false,
        configurable: true
    });
    ItemCreateUpdateForm.prototype.handleSubmit = function () {
        var _this = this;
        var route = !this.item ? (0, route_1.default)(routes_1.CREATE_ITEM_ACTION, {
            board: this.board.abbr,
        }) : (0, route_1.default)(routes_1.UPDATE_ITEM_ACTION, {
            board: this.board.abbr,
            item: this.item.hash_id
        });
        this.form.transform(function (data) { return (__assign(__assign({}, data), { biddingStartedAt: data.changeStartTime && data.biddingStartedAt ? (0, moment_1.default)(data.biddingStartedAt).format("YYYY-MM-DD HH:mm:00") : "", biddingEndedAt: data.biddingEndedAt ? (0, moment_1.default)(data.biddingEndedAt).format("YYYY-MM-DD HH:mm:59") : "", initialPrice: _this.parsedInitialPrice, itemValue: _this.parsedItemValue })); }).post(route, {
            onSuccess: function (response) {
                var flash = response.props.flash;
                (0, toastNotification_1.default)(_this.$toast, flash.message, flash.messageColor);
                _this.populateForm();
            },
            onError: function (error) {
                console.error(error);
                (0, toastNotification_1.default)(_this.$toast, "There were some errors submitting this form.", 'error');
            }
        });
    };
    ItemCreateUpdateForm.prototype.toggleToDelete = function (image) {
        this.$set(image, "to_delete", !image.to_delete);
    };
    ItemCreateUpdateForm.prototype.formatStartAt = function () {
        var date = (0, moment_1.default)().format("YYYY-MM-DD 12:00");
        if (this.item && this.item.bidding_started_at) {
            return (0, moment_1.default)(this.item.bidding_started_at, "YYYY-MM-DD h:mm a").toISOString();
        }
        else {
            return date;
        }
    };
    ItemCreateUpdateForm.prototype.formatEndAt = function () {
        var date = (0, moment_1.default)().format("YYYY-MM-DD 12:00");
        if (this.item && this.item.bidding_ended_at) {
            return (0, moment_1.default)(this.item.bidding_ended_at, "YYYY-MM-DD h:mm a").toISOString();
        }
        else {
            return date;
        }
    };
    ItemCreateUpdateForm.prototype.populateForm = function () {
        this.form = (this.item && this.item.bid_count === 0) || !this.item
            ? this.$inertia.form({
                images: [],
                name: this.item ? this.item.name : "",
                content: this.item ? this.item.content : "<p></p>",
                itemValue: this.item ? (0, currency_js_1.default)(this.item.item_value).format() : "$0.00",
                initialPrice: this.item ? (0, currency_js_1.default)(this.item.initial_price).format() : "$0.00",
                isOpenToBid: this.item
                    ? this.item.is_active
                    : false,
                changeStartTime: this.item
                    ? this.item.start_is_manually_set
                    : false,
                biddingStartedAt: this.formatStartAt(),
                biddingEndedAt: this.formatEndAt(),
                bank: this.item
                    ? this.item.decrypted_bank
                    : this.defaultBank,
                board: this.item
                    ? this.item.board_id
                    : this.board.id,
                currentImages: this.item && this.item.images.length
                    ? lodash_1.default.cloneDeep(this.item.images)
                    : null,
            })
            : this.$inertia.form({
                images: [],
                content: this.item ? this.item.content : "<p></p>",
                currentImages: this.item && this.item.images.length
                    ? lodash_1.default.cloneDeep(this.item.images)
                    : null,
            });
    };
    ItemCreateUpdateForm.prototype.beforeMount = function () {
        this.populateForm();
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: false })
    ], ItemCreateUpdateForm.prototype, "item", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: true })
    ], ItemCreateUpdateForm.prototype, "board", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: String, required: false })
    ], ItemCreateUpdateForm.prototype, "defaultBank", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: true })
    ], ItemCreateUpdateForm.prototype, "permissions", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Array, required: false })
    ], ItemCreateUpdateForm.prototype, "boards", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: Array })
    ], ItemCreateUpdateForm.prototype, "cachedBanks", void 0);
    ItemCreateUpdateForm = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: components
        })
    ], ItemCreateUpdateForm);
    return ItemCreateUpdateForm;
}(vue_property_decorator_1.Vue));
exports.default = ItemCreateUpdateForm;
